import { createContext } from 'react'

import { createAssignManagerStore } from '../store/createStore'

export const AssignManagerStoreContext = createContext<
  ReturnType<typeof createAssignManagerStore> | undefined
>(undefined)
